export default __webpack_public_path__ + "static/media/2359.519bd3c5.png";